import { render, staticRenderFns } from "./LaundryItemDelete.vue?vue&type=template&id=8e61ac3c"
import script from "./LaundryItemDelete.vue?vue&type=script&lang=js"
export * from "./LaundryItemDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports